import { uint16, uint32, uint8 } from '../../utils';
import { appWidget_id } from '../dataSource';

export const genSlotBin = (item: any) => {
  const { slotType, isSlotGroup, appWidgetID, slotGroupBuf } = item;
  if (slotType === 'condition') return genSlotConditionBin(item);
  // 如果slot是appWidget，slotItemCount始终是0
  const slotItemCount = appWidgetID
    ? uint8(0)
    : item.onlyOneChild
    ? uint8(1)
    : uint8(item.slotItemUidTable.length);
  let app_widget_id;
  if (appWidgetID) {
    for (let i = 0; i < appWidget_id.length; i++) {
      if (appWidgetID == appWidget_id[i].split('@')[0]) {
        app_widget_id = appWidget_id[i].split('@')[1];
      }
    }
  }

  const slotReserved = uint8(0);
  let slotFlagsNumber = 0;
  if (item.slotPosTable.length > 0) {
    slotFlagsNumber += 1;
  }
  if (isSlotGroup) {
    slotFlagsNumber += 1 << 1;
  }
  if (slotType == 'time') {
    slotFlagsNumber += 1 << 4;
  } else if (slotType == 'dial') {
    slotFlagsNumber += 2 << 4;
  } else if (slotType === 'appWidget') {
    slotFlagsNumber += 3 << 4;
  } else if (slotType === 'font') {
    slotFlagsNumber += 5 << 4;
  } else if (slotType === 'dualTime') {
    slotFlagsNumber += 6 << 4;
  }

  if (item.slotPosTable.length > 0) {
    slotFlagsNumber += item.slotPosTable.length << 8;
  }
  const slotFlags = uint16(slotFlagsNumber);

  let slotUidWidget_OR_appWidget = Buffer.alloc(0);
  if (appWidgetID) {
    slotUidWidget_OR_appWidget = Buffer.concat([
      uint16(Number(app_widget_id)),
      uint16(0),
      uint32(0)
    ]);
  } else {
    slotUidWidget_OR_appWidget = item.slotItemUidData;
  }

  const bin = Buffer.concat([
    slotItemCount,
    slotReserved,
    slotFlags,
    slotUidWidget_OR_appWidget,
    Buffer.concat(item.slotPosTable),
    isSlotGroup ? slotGroupBuf : Buffer.alloc(0)
  ]);

  return bin;
};

const genSlotConditionBin = (item: any) => {
  const { widgets_count, condition_widgets, pos_tables } = item;
  const reserved = 0;

  let flags = 7 << 4;
  if (pos_tables.length > 0) {
    flags = flags + 1 + (pos_tables.length << 8);
  }
  const condition_widget = condition_widgets.map((it: any) => {
    const { uid_condition, widget_cnt, select_method, uid_widgets } = it;
    return Buffer.concat([
      uid_condition,
      uint16(widget_cnt),
      uint16(select_method),
      Buffer.concat(uid_widgets)
    ]);
  });

  const bin = Buffer.concat([
    uint8(widgets_count),
    uint8(reserved),
    uint16(flags),
    Buffer.concat(condition_widget),
    Buffer.concat(pos_tables)
  ]);
  return bin;
};
